import makeCommandDispatcher from "web/core/apollo/makeCommandDispatcher";
import SubscribeToInStockAlert from "./SubscribeToInStockAlert.gql";
import UnsubscribeToInStockAlert from "./UnsubscribeToInStockAlert.gql";

const withInStockAlertMutations = () =>
  makeCommandDispatcher({
    subscribeToInStockAlert:
      ({ sku }) =>
      (email) => ({
        options: {
          mutation: SubscribeToInStockAlert,
          variables: { sku, email },
        },
      }),
    unsubscribeToInStockAlert:
      ({ sku }) =>
      () => ({
        options: {
          mutation: UnsubscribeToInStockAlert,
          variables: { sku },
        },
      }),
  });

export default withInStockAlertMutations;
